<form
  novalidate
  [formGroup]="form"
  class="search-form"
  (submit)="applyFilters()"
  [ngClass]="{
    'search-form--filters-open': isFiltersVisible,
    'search-form--main-filters-open': isMainFiltersOpen
  }"
>
  <mat-form-field appearance="outline" class="search-form__control">
    <mzima-client-button matPrefix [iconOnly]="true" fill="clear" color="secondary">
      <mat-icon icon svgIcon="search-small"></mat-icon>
    </mzima-client-button>
    <input
      matInput
      [(ngModel)]="searchQuery"
      (ngModelChange)="searchPosts()"
      class="search-form__form-control"
      [ngModelOptions]="{ standalone: true }"
      [placeholder]="'global_filter.search' | translate"
    />
    <mzima-client-button
      matSuffix
      fill="clear"
      [iconOnly]="true"
      color="secondary"
      *ngIf="searchQuery?.length"
      (buttonClick)="clearPostsResults()"
    >
      <mat-icon icon svgIcon="close"></mat-icon>
    </mzima-client-button>
  </mat-form-field>
  <mzima-client-button
    [fill]="isDesktop ? 'clear' : 'outline'"
    [color]="isDesktop ? 'gray' : 'secondary'"
    class="search-form__filters"
    *ngIf="isDesktop || isMapView"
    (buttonClick)="toggleFilters(!isFiltersVisible)"
    [data-qa]="'search-form__filters'"
  >
    <span>{{ 'app.filters' | translate }}</span>
    <mat-icon iconPrefix svgIcon="filters"></mat-icon>
  </mzima-client-button>

  <div
    data-filter-highlight
    class="search-form__main-filters"
    [ngClass]="{ 'search-form__main-filters--closed': !isMainFiltersOpen && !isOnboardingActive }"
  >
    <button
      type="button"
      (click)="toggleMainFilters()"
      class="search-form__main-filters__toggle-btn"
    >
      <mat-icon svgIcon="angle-right"></mat-icon>
    </button>

    <div class="search-form__main-filters__inner">
      <span class="search-form__main-filters__total" *ngIf="total !== undefined">
        {{ 'post.search_results' | translate }} {{ total }}
      </span>

      <div class="collection-info" *ngIf="collectionInfo">
        <div class="collection-info__head">
          <span class="collection-info__title">
            {{ 'app.collection' | translate }}
            "{{ collectionInfo.name }}"
          </span>
          <mzima-client-button
            fill="clear"
            size="small"
            (buttonClick)="clearCollection()"
            class="filter-group__head__button"
          >
            {{ 'nav.clear' | translate }}
          </mzima-client-button>
        </div>

        <mat-slide-toggle
          *ngIf="isLoggedIn"
          class="notifications-toggle"
          [(ngModel)]="isNotificationsOn"
          [disabled]="isNotificationLoading"
          [ngModelOptions]="{ standalone: true }"
          (change)="changeNorificationStatus($event, collectionInfo.id.toString())"
        >
          {{ 'nav.notifications' | translate }}
        </mat-slide-toggle>

        <div class="collection-info__description" *ngIf="collectionInfo.description?.length">
          {{ collectionInfo.description }}
        </div>
      </div>

      <div class="collection-info" *ngIf="activeSavedSearch">
        <div class="collection-info__head">
          <span class="collection-info__title">
            {{ 'global_filter.saved_filter' | translate }}
            "{{ activeSavedSearch.name }}"
          </span>
          <mzima-client-button
            fill="clear"
            size="small"
            (buttonClick)="clearSavedFilter()"
            class="filter-group__head__button"
          >
            {{ 'nav.clear' | translate }}
          </mzima-client-button>
        </div>

        <mat-slide-toggle
          class="notifications-toggle"
          [(ngModel)]="isNotificationsOn"
          [disabled]="isNotificationLoading"
          [ngModelOptions]="{ standalone: true }"
          *ngIf="isLoggedIn && activeSavedSearch.id"
          (change)="changeNorificationStatus($event, activeSavedSearch.id.toString())"
        >
          {{ 'nav.notifications' | translate }}
        </mat-slide-toggle>

        <div class="collection-info__description" *ngIf="activeSavedSearch.description?.length">
          {{ activeSavedSearch.description }}
        </div>
      </div>

      <ng-container *ngIf="surveysLoaded; else loader">
        <mat-tab-group
          class="tabs"
          dynamicHeight
          disableRipple
          disablePagination
          animationDuration="0ms"
        >
          <mat-tab [label]="'app.surveys' | translate" [disabled]="!surveyList.length">
            <div class="tabs__clear">
              <mzima-client-button
                fill="clear"
                size="small"
                class="filter-group__head__button"
                (buttonClick)="clearFilter('form')"
              >
                {{ 'nav.clear' | translate }}
              </mzima-client-button>
            </div>
            <mat-selection-list
              name="surveys"
              class="selection-list"
              formControlName="form"
              [data-qa]="'survey-selection-list'"
            >
              <mat-list-option
                *ngFor="let survey of surveyList"
                [selected]="survey.checked"
                color="primary"
                [value]="survey.id"
                checkboxPosition="before"
                class="selection-list__option"
                [ngStyle]="{ '--color': survey.color }"
                [data-qa]="'survey-select-item'"
              >
                <span class="selection-list__option__border"></span>
                {{ survey.name }}
                <span class="selection-list__option__total">{{ survey.total }}</span>
              </mat-list-option>
            </mat-selection-list>

            <div class="filter-group__info" *ngIf="isMapView">
              <span *ngIf="notMappedPostsCount <= 0">{{
                'global_filter.unmapped_none' | translate
              }}</span>
              <span *ngIf="notMappedPostsCount === 1">{{
                'global_filter.unmapped_start_one' | translate
              }}</span>
              <span *ngIf="notMappedPostsCount >= 2">{{
                'global_filter.unmapped_start_many' | translate
              }}</span>
              <a [routerLink]="['feed']" *ngIf="notMappedPostsCount >= 1">
                {{ notMappedPostsCount }} post{{ notMappedPostsCount >= 2 ? 's' : '' }}
              </a>
              <span *ngIf="notMappedPostsCount >= 1">{{
                'global_filter.unmapped_end' | translate
              }}</span>
            </div>
          </mat-tab>

          <mat-tab [label]="'global_filter.source' | translate">
            <div class="tabs__clear">
              <mzima-client-button
                fill="clear"
                size="small"
                class="filter-group__head__button"
                (buttonClick)="clearFilter('source')"
              >
                {{ 'nav.clear' | translate }}
              </mzima-client-button>
            </div>
            <mat-selection-list name="source" class="selection-list" formControlName="source">
              <ng-container *ngFor="let source of sources">
                <mat-list-option
                  [selected]="source.checked"
                  color="primary"
                  [value]="source.value"
                  checkboxPosition="before"
                  class="selection-list__option"
                >
                  {{ source.name }}
                  <span class="selection-list__option__total">{{ source.total }}</span>
                </mat-list-option>
              </ng-container>
            </mat-selection-list>
          </mat-tab>
        </mat-tab-group>
      </ng-container>
    </div>
  </div>

  <div
    data-filter-highlight
    class="search-form__filters-panel"
    *ngIf="isDesktop || isFiltersVisible"
    [ngClass]="{ 'search-form__filters-panel--open': isFiltersVisible }"
  >
    <div class="search-form__filters-panel__head" *ngIf="!isDesktop">
      <h3>Filters and sorting</h3>
      <mzima-client-button
        tabindex="-1"
        fill="outline"
        [iconOnly]="true"
        color="light-gray"
        [data-qa]="'btn-close'"
        class="modal__close-btn"
        (buttonClick)="toggleFilters(false)"
        ariaLabel="{{ 'modal.button.close' | translate }}"
      >
        <mat-icon icon svgIcon="close"></mat-icon>
      </mzima-client-button>
    </div>

    <div class="search-form__filters-panel__inner">
      <ng-container *ngIf="!isDesktop">
        <app-filter-control
          class="search-form__filters-panel__item"
          formControlName="form"
          [options]="surveyList"
          [fields]="['id', 'name']"
          (clear)="clearFilter('form')"
          [type]="filterType.Multiselect"
          [title]="'app.surveys' | translate"
          [badge]="form.controls['form'].value?.length || null"
        >
          <div class="clear-button" suffix>
            <mzima-client-button
              fill="clear"
              size="small"
              class="filter-group__head__button"
              (buttonClick)="clearFilter('form')"
            >
              {{ 'nav.clear' | translate }}
            </mzima-client-button>
          </div>
        </app-filter-control>

        <app-filter-control
          class="search-form__filters-panel__item"
          formControlName="source"
          [options]="sources"
          [fields]="['value', 'name']"
          [type]="filterType.Multiselect"
          (clear)="clearFilter('source')"
          [title]="'global_filter.source' | translate"
          [badge]="form.controls['source'].value?.length || null"
        >
          <div class="clear-button" suffix>
            <mzima-client-button
              fill="clear"
              size="small"
              class="filter-group__head__button"
              (buttonClick)="clearFilter('source')"
            >
              {{ 'nav.clear' | translate }}
            </mzima-client-button>
          </div>
        </app-filter-control>
      </ng-container>

      <app-filter-control
        class="search-form__filters-panel__item"
        [(ngModel)]="activeSavedSearchValue"
        [ngModelOptions]="{ standalone: true }"
        [title]="'global_filter.saved_filters' | translate"
        [type]="filterType.Select"
        [badge]="activeSavedSearchValue ? 1 : null"
        [options]="savedSearches"
        [canEdit]="isEditAvailable"
        (clear)="applySavedFilter(null)"
        (editOption)="saveSearch($event)"
        (filterChange)="applySavedFilter($event)"
      >
        <mzima-client-button
          *ngIf="canCreateSearch"
          suffix
          fill="clear"
          class="save-filter-button"
          (buttonClick)="saveSearch()"
        >
          <mat-icon iconPrefix svgIcon="plus"></mat-icon>
          {{ 'global_filter.save_new_filter' | translate }}
        </mzima-client-button>
        <span class="no-saved-filters" postfix *ngIf="savedSearches?.length === 0"
          >No saved filters. Saved filter(s) will appear here for you to select once made
          available.</span
        >
      </app-filter-control>

      <app-filter-control
        class="search-form__filters-panel__item"
        formControlName="status"
        [options]="statuses"
        [fields]="['value', 'name']"
        [type]="filterType.Multiselect"
        (clear)="clearFilter('status')"
        [title]="'global_filter.status' | translate"
        [badge]="form.controls['status'].value?.length || null"
      >
        <div class="clear-button" suffix>
          <mzima-client-button
            fill="clear"
            size="small"
            class="filter-group__head__button"
            (buttonClick)="clearFilter('status')"
          >
            {{ 'nav.clear' | translate }}
          </mzima-client-button>
        </div>
      </app-filter-control>

      <app-filter-control
        class="search-form__filters-panel__item"
        *ngIf="categoriesData?.length"
        formControlName="tags"
        [options]="categoriesData"
        (clear)="clearFilter('tags')"
        [type]="filterType.Multilevelselect"
        [title]="'app.categories' | translate"
        [badge]="form.controls['tags'].value?.length || null"
        [selectedFields]="form.controls['tags'].value"
      >
      </app-filter-control>

      <app-filter-control
        class="search-form__filters-panel__item"
        formControlName="date"
        [type]="filterType.Daterange"
        (clear)="clearFilter('date')"
        [title]="'global_filter.date_range' | translate"
        [badge]="form.controls['date'].value?.start || form.controls['date'].value?.end ? 1 : null"
      >
        <div class="clear-button" suffix>
          <mzima-client-button
            fill="clear"
            size="small"
            class="filter-group__head__button"
            (buttonClick)="clearFilter('date')"
          >
            {{ 'nav.clear' | translate }}
          </mzima-client-button>
        </div>
      </app-filter-control>

      <app-filter-control
        class="search-form__filters-panel__item"
        formControlName="center_point"
        [type]="filterType.Location"
        (clear)="clearFilter('center_point')"
        [title]="'global_filter.location' | translate"
        [badge]="form.controls['center_point'].value.location?.lat ? 1 : null"
      >
        <div class="clear-button" suffix>
          <mzima-client-button
            fill="clear"
            size="small"
            class="filter-group__head__button"
            (buttonClick)="clearFilter('center_point')"
          >
            {{ 'nav.clear' | translate }}
          </mzima-client-button>
        </div>
      </app-filter-control>

      <div class="search-form__filters-panel__item search-form__filters-panel__item--controls">
        <mzima-client-button
          fill="outline"
          color="secondary"
          [disabled]="form.disabled"
          class="search-form__button"
          (buttonClick)="resetSavedFilter()"
          [data-qa]="'search-form__button'"
        >
          {{ 'global_filter.clear_all_filters' | translate }}
        </mzima-client-button>
        <mzima-client-button
          *ngIf="!isDesktop"
          (buttonClick)="applyAndClose()"
          [disabled]="form.disabled"
          class="search-form__button"
        >
          Apply filters
        </mzima-client-button>
      </div>
    </div>
  </div>
</form>

<ng-template #loader>
  <app-spinner class="spinner"></app-spinner>
</ng-template>
